<template>
    <div class="vgap-3 w-100">
        <channel-svg v-bind:svg-name="svgName" />
        <div>
            <div
                v-for="line in helpTextArray"
                v-bind:key="line.id">
                {{ line.text }}
                <br />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from "vue";
    import channelSvg from "./channelSvg.vue";

    const props = defineProps({
        svgName: { type: String, required: false, default: null },
        helpText: { type: String, required: true }
    });

    const helpTextArray = computed(() => {
        return props.helpText.split("\n").map((text, index) => ({ id: index, text: text }));
    });
</script>
